import { Badge } from 'react-bootstrap';
import styled from 'styled-components';

const StyledBadge = styled(Badge)`
    cursor: default;
`;

export default StyledBadge;
